import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—July 2005" />
	<Old2005BlogPage>
		<h2>July 2005</h2>






		<h3 className="blogdate">
		Sunday, July 24, 2005
		</h3>






		<h4 className="blogitemtitle">
		Where Have I Been?
		</h4>





			<div className="blogitembody">
			<p>I was in Carnarvon for three weeks; two weeks working on grape vines for the Durmanich farm, and one week helping my new friend, Cormac, repair his 4x4. Kelly, Cormac and I travelled a short way north and drove off-road to Warroora Station, where we camped for one week. We set our tents among old sand dunes and battled black flies each 25-30 degree day. We walked over the dunes to Stevens Beach and snorkelled in the coral reef (Ningaloo Reef), where Cormac speared a couple cuttlefish (squid related)! We saw turtles, starfish, whales, octopus, rays, urchins, sea cucumbers, and many cool and exciting sea creatures!</p><p>We cooked some of the cuttlefish and used the remaining amount as our week's supply of bait for fishing. We cooked freshly caught snapper almost every night on the coals of our fire! I also steamed perfect rice for breakfasts and dinners on the fire coals, as well as vegetables from the Carnarvon farms. There are absolutely no facilities here so we brought stores of petrol fuel and water, and dug holes in the dunes for our toilets! I washed our pots and plates in the beach sand as warm, emerald sea water splashed about me. Warroora Station was paradise to us but isn’t for everyone, which explains why there were so few people there! We lived like aboriginals for a week! I went skinny dipping with my snorkel and mask nearly every day!</p><p>A week ago we left Warroora and came to Coral Bay, which is a resort center for Ningaloo Reef. An expensive bit of civilization compared to Warroora, we managed to stay rent-free while visiting Jess (a fiend of Kelly’s and Cormac’s). Every day is spectacular here with warm sun, a great bakery, and very spectacular snorkeling! Jess works at the Ningaloo Reef Resort Hotel (which has a pub) and I performed a two-hour gig for about 100 people… well, there was much less when I finished but the people that stayed enjoyed it! That was on July 19, and then on July 22 I performed again at the Ningaloo Club, to a room of maybe 70 people… this went very well and the manager paid me 150% of the agreed salary! I’m playing again tonight at the Ningaloo Club, and then tomorrow we leave (with Jess) for Kirijini National Park to do some hiking and camping! Should be fun!</p>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:04 PM &nbsp;

			</div>









		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
